
import React, { useState } from "react";

interface MenuItem {
    name: string;
    description: string;
    ingredients: string;
    price: number;
    image_url?: string;
}

interface BotMessageProps {
    content: string;
    menuItems?: MenuItem[];
}

export default function BotMessage({
                                       content,
                                       menuItems
                                   }: BotMessageProps) {
    return (
        <div className="w-full min-w-0 space-y-4">

            {/* AI recommendation text */}
            <div
                className="whitespace-pre-wrap break-words text-sm leading-relaxed text-white"
            >
                {content}
            </div>

            {/* Recommended menu items */}
            {Array.isArray(menuItems) && menuItems.length > 0 && (
                <div className="w-full min-w-0 space-y-4">
                    {menuItems.map((item, index) => (
                        <MenuCard
                            key={`${item.name}-${index}`}
                            item={item}
                        />
                    ))}
                </div>
            )}

        </div>
    );
}

function MenuCard({ item }: { item: MenuItem }) {
    const [imageError, setImageError] = useState(false);

    return (
        <div
            className="w-full min-w-0 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm"
        >

            {/* Food image */}
            {item.image_url && !imageError && (
                <div className="w-full overflow-hidden bg-gray-100">
                    <img
                        src={item.image_url}
                        alt={item.name}
                        loading="lazy"
                        onError={() => setImageError(true)}
                        className="block h-44 w-full object-cover"
                    />
                </div>
            )}

            {/* Dish details */}
            <div className="min-w-0 space-y-2 p-4">

                <div className="flex flex-col gap-1">
                    <h4 className="break-words text-base font-bold leading-snug text-blue-700">
                        {item.name}
                    </h4>

                    <span className="text-lg font-bold text-indigo-600">
                        ${Number(item.price).toFixed(2)}
                    </span>
                </div>

                {item.description && (
                    <p className="break-words text-sm leading-relaxed text-gray-600">
                        {item.description}
                    </p>
                )}

                {item.ingredients && (
                    <div className="border-t border-gray-100 pt-3">
                        <p className="break-words text-xs leading-relaxed text-gray-500">
                            <span className="font-semibold text-gray-700">
                                Ingredients:
                            </span>{" "}
                            {item.ingredients}
                        </p>
                    </div>
                )}

            </div>
        </div>
    );
}
